module.exports = __webpack_public_path__ + "img/support.b1d896e3.png";